module.exports = __webpack_public_path__ + "img/image-style-07.7eaf9969.svg";